import React, { Suspense } from "react";
import NavigationBar from "./NavigationBar";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import Footer from "./Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "leaflet/dist/leaflet.css";
import { Routes, Route } from "react-router-dom";
import { Container } from "react-bootstrap";
const Home = React.lazy(() => import("./pages/index"));
const Products = React.lazy(() => import("./pages/products"));
const WhyUs = React.lazy(() => import("./pages/why-us"));
const Contact = React.lazy(() => import("./pages/contact"));
const Services = React.lazy(() => import("./pages/services"));
const ProductDetail = React.lazy(() => import("./pages/product-details"));

function App() {
  return (
    <div className="d-flex flex-column min-vh-100 ">
      <NavigationBar />
      <Suspense>
        <Container fluid className="p-3">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/why-us" element={<WhyUs />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/products/:id" element={<ProductDetail />} />
          </Routes>
        </Container>
      </Suspense>
      <Footer />
      <div></div>
    </div>
  );
}

export default App;
